import { TRANSITION_MOUNT_TYPE } from 'enums'

export const getComposedAssets = ({
  allAssets,
  transitions,
  playingMediaAssetIds,
}) => transitions.filter(transition => transition?.mountType === TRANSITION_MOUNT_TYPE.BETWEEN)
  .reduce((acc, transition) => [
    ...acc,
    ...([ allAssets.find(el => transition.isAttachedToRight(el.id)) ]
      .filter(asset => playingMediaAssetIds.every(id => id !== asset.id))),
  ], [])
